// test348
(348 && 0);
